import { rankingItems } from '@/mocks/homepage';

const rankColors: Record<number, string> = {
  1: 'bg-accent-500',
  2: 'bg-accent-400',
  3: 'bg-accent-300',
};

const changeIcons: Record<string, string> = {
  up: 'ri-arrow-up-line text-primary-500',
  down: 'ri-arrow-down-line text-foreground-400',
  new: 'ri-checkbox-blank-circle-fill text-accent-500',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-900">热度榜单</h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">全站最受欢迎的擦边内容实时排行</p>
        </div>

        <div className="space-y-2 md:space-y-3">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-background-50 rounded-lg hover:bg-background-200/70 transition-colors duration-200 cursor-pointer"
            >
              <div
                className={`flex-shrink-0 w-8 h-8 md:w-9 md:h-9 rounded-lg flex items-center justify-center text-white text-sm font-bold ${
                  rankColors[item.rank] || 'bg-foreground-400'
                }`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-bold text-foreground-900 truncate">{item.title}</h3>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-xs px-1.5 py-0.5 bg-secondary-100 text-secondary-700 rounded whitespace-nowrap">{item.tag}</span>
                  <span className="text-xs text-foreground-500">{item.heat}</span>
                </div>
              </div>
              <div className="flex-shrink-0">
                <i className={`text-sm ${changeIcons[item.change]}`}></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}